/* ======================================================================================================================
   SPLENDIDO — Badge „i" sulle immagini generate con IA (AI Act art. 50(4))
   ======================================================================================================================
   Comportamento del badge in galleria e nel visore a schermo intero.

   ⚠️ NESSUNA STRINGA QUI DENTRO (regola d'oro i18n): testo ed etichetta arrivano dagli attributi `data-` scritti da
      Liquid a partire dalle chiavi locale, così T-Lab traduce normalmente e non resta tedesco fisso nelle altre lingue.

   ⚠️ Il file vive in `assets/` e non dentro la sezione: il markup della galleria viene rigenerato da Prestige a ogni
      cambio variante (`createContextualFragment` RIESEGUE gli <script> interni) → gli ascoltatori stanno su `document`
      e la delega regge qualsiasi ridisegno. Vedi la lezione „il codice di uno stato non va dentro il ramo che rende
      l'altro stato" in `tema-mod/_AREA-MEMORY.md`.
   ====================================================================================================================== */

(function () {
  if (window.__spAiBadgeInit) return;
  window.__spAiBadgeInit = true;

  var SEL_BADGE = '.sp-ai-badge';
  var SEL_POP = '.sp-ai-pop';

  function popDi(badge) {
    var id = badge.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function chiudi(badge) {
    var pop = popDi(badge);
    if (pop) pop.hidden = true;
    badge.setAttribute('aria-expanded', 'false');
  }

  function chiudiTutti(tranne) {
    document.querySelectorAll(SEL_BADGE + '[aria-expanded="true"]').forEach(function (b) {
      if (b !== tranne) chiudi(b);
    });
  }

  function apri(badge) {
    var pop = popDi(badge);
    if (!pop) return;
    chiudiTutti(badge);
    pop.hidden = false;
    badge.setAttribute('aria-expanded', 'true');
  }

  function alterna(badge) {
    if (badge.getAttribute('aria-expanded') === 'true') chiudi(badge);
    else apri(badge);
  }

  /* Fase di CATTURA su document: la cella della galleria ha un suo click che apre lo zoom (Prestige) e il visore ha i
     propri gesti. Intercettando prima di tutti, un tocco sulla „i" non apre più lo zoom. */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var badge = t.closest(SEL_BADGE);
      if (badge) {
        e.preventDefault();
        e.stopPropagation();
        alterna(badge);
        return;
      }
      if (t.closest(SEL_POP)) {
        e.stopPropagation(); /* leggere il testo non deve aprire lo zoom */
        return;
      }
      chiudiTutti();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var aperti = document.querySelectorAll(SEL_BADGE + '[aria-expanded="true"]');
      if (!aperti.length) return;
      e.stopPropagation(); /* non chiudere anche il visore al primo Esc */
      aperti.forEach(chiudi);
    }
  }, true);

  /* Scorrendo la galleria il riquadro resterebbe aperto sopra un'altra foto. */
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('product-gallery__carousel')) chiudiTutti();
    },
    true
  );

  /* --------------------------------------------------------------------------------------------------------------------
     VISORE A SCHERMO INTERO
     La galleria (snippet `product-gallery.liquid`) sa quale slide è un media IA e chiama `window.spAiLightbox.aggiorna`.
     Qui si crea UNA sola pastiglia dentro il visore e la si mostra/nasconde a ogni cambio di slide.
     -------------------------------------------------------------------------------------------------------------------- */
  function testi() {
    var src = document.querySelector('[data-sp-ai-testo]');
    if (!src) return null;
    return {
      testo: src.getAttribute('data-sp-ai-testo') || '',
      titolo: src.getAttribute('data-sp-ai-titolo') || '',
      label: src.getAttribute('data-sp-ai-label') || ''
    };
  }

  /* Rettangolo della PARTE VISIBILE del media: nel visore la foto è centrata e lascia bande vuote sopra e sotto
     (o ai lati). Ancorare il badge al bordo dello schermo lo farebbe finire FUORI dalla foto — segnalazione del
     capo con screenshot del 07/08/2026, dove la „i" stava sul bianco sotto l'immagine. */
  function rettangoloVisibile(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    var nw = 0, nh = 0;
    if (el.tagName === 'VIDEO') { nw = el.videoWidth; nh = el.videoHeight; }
    else if (el.tagName === 'IMG') { nw = el.naturalWidth; nh = el.naturalHeight; }
    else { var dentro = el.querySelector('video, img'); if (dentro) return rettangoloVisibile(dentro); }
    if (!nw || !nh || !r.width || !r.height) return r;
    var scala = Math.min(r.width / nw, r.height / nh);
    var w = nw * scala, h = nh * scala;
    return {
      left: r.left + (r.width - w) / 2,
      top: r.top + (r.height - h) / 2,
      width: w,
      height: h,
      bottom: r.top + (r.height + h) / 2
    };
  }

  var ultimoPswp = null;

  function posizionaNelVisore() {
    var pswp = ultimoPswp;
    if (!pswp || !pswp.element) return;
    var badge = pswp.element.querySelector(':scope > .sp-ai-badge');
    var pop = pswp.element.querySelector(':scope > .sp-ai-pop');
    if (!badge || badge.hidden) return;
    var contenuto = pswp.currSlide && pswp.currSlide.content ? pswp.currSlide.content.element : null;
    var rc = rettangoloVisibile(contenuto);
    if (!rc || !rc.width) return;
    var lato = badge.getBoundingClientRect().width || 16;
    var sx = Math.round(rc.left + 14);
    var sb = Math.round(window.innerHeight - rc.bottom + 19);
    badge.style.insetInlineStart = sx + 'px';
    badge.style.insetBlockEnd = sb + 'px';
    if (pop) {
      pop.style.insetInlineStart = sx + 'px';
      pop.style.insetBlockEnd = sb + lato + 10 + 'px';
      pop.style.width = 'min(258px, ' + Math.max(180, Math.round(rc.width) - 28) + 'px)';
    }
  }

  window.spAiLightbox = {
    aggiorna: function (pswp, isAi) {
      var root = pswp && pswp.element ? pswp.element : pswp; /* accetta anche un semplice elemento (prove) */
      if (!root || !root.querySelector) return;
      var t = testi();
      if (!t || !t.testo) return;

      var badge = root.querySelector(':scope > .sp-ai-badge');
      if (!badge) {
        badge = document.createElement('button');
        badge.type = 'button';
        badge.className = 'sp-ai-badge';
        badge.setAttribute('aria-label', t.label);
        badge.setAttribute('aria-expanded', 'false');
        badge.setAttribute('aria-controls', 'sp-ai-pop-lightbox');
        badge.innerHTML = '<span class="sp-ai-badge__pill" aria-hidden="true"><span>i</span></span>';

        var pop = document.createElement('div');
        pop.className = 'sp-ai-pop';
        pop.id = 'sp-ai-pop-lightbox';
        pop.setAttribute('role', 'note');
        pop.hidden = true;
        var titolo = document.createElement('span');
        titolo.className = 'sp-ai-pop__title';
        titolo.textContent = t.titolo;
        pop.appendChild(titolo);
        pop.appendChild(document.createTextNode(t.testo));

        root.appendChild(badge);
        root.appendChild(pop);
      }

      chiudi(badge); /* cambiando slide il riquadro si richiude sempre */
      badge.hidden = !isAi;

      if (pswp && pswp.element) {
        ultimoPswp = pswp;
        /* la slide viene dimensionata subito dopo l'evento: si riposiziona qualche volta invece di indovinare */
        posizionaNelVisore();
        setTimeout(posizionaNelVisore, 120);
        setTimeout(posizionaNelVisore, 400);
      }
    }
  };

  window.addEventListener('resize', posizionaNelVisore, { passive: true });
  window.addEventListener('orientationchange', function () { setTimeout(posizionaNelVisore, 250); });
})();
